// ─── Google Sheets Sync ───────────────────────────────────────────────────────
// Uses Google Sheets API v4 via a simple Apps Script Web App (no OAuth needed)
// The Web App URL is now configured from the "My Business" tab in-app (Settings →
// Google Sheets Sync) instead of being hardcoded here — see GOOGLE_SHEETS_SETUP.txt.

// Column headers
const CANDIDATE_HEADERS = [
  'Employee ID','Name','Phone','Email','Visa','Industry','Experience (yrs)',
  'Originally From','Years in USA','Availability','Has Car','Couple','Skills',
  'Stage','Added By','Added Date','Notes'
];
const CLIENT_HEADERS = [
  'Name','Contact','Phone','Email','Industry','City','State','Openings',
  'Hourly Wage','Skills Needed','Car Required','Legal Only','Placement Fee',
  'Discount/Unit','Rating','Added By','Added Date','Notes'
];

async function sheetsRequest(url, action, sheet, data) {
  if (!url) return;
  try {
    await fetch(url, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action, sheet, data }),
    });
  } catch (e) {
    console.warn('Sheets sync failed:', e.message);
  }
}

export async function syncCandidateToSheets(candidate, url) {
  if (!url) return;
  const row = [
    candidate.employeeId || '',
    candidate.name || '',
    candidate.phone || '',
    candidate.email || '',
    candidate.visa || '',
    candidate.industry || '',
    candidate.experience || '',
    candidate.originCountry || '',
    candidate.yearsInUSA || '',
    candidate.availability || '',
    candidate.hasCar || 'No',
    candidate.isCouple || 'No',
    (candidate.skills || []).join(', '),
    candidate.stage || 'New',
    candidate.addedByName || '',
    candidate.addedAt || '',
    candidate.notes || '',
  ];
  await sheetsRequest(url, 'upsert', 'Candidates', { id: candidate.id, headers: CANDIDATE_HEADERS, row });
}

export async function syncClientToSheets(client, url) {
  if (!url) return;
  const row = [
    client.name || '',
    client.contact || '',
    client.phone || '',
    client.email || '',
    client.industry || '',
    client.city || '',
    client.state || '',
    client.openings || '',
    client.wage || '',
    client.skills || '',
    client.carNeeded || 'No',
    client.legalOnly || 'No',
    client.placementFee || '',
    client.discPerUnit || '',
    client.rating || '',
    client.addedByName || '',
    client.addedAt || '',
    client.notes || '',
  ];
  await sheetsRequest(url, 'upsert', 'Clients', { id: client.id, headers: CLIENT_HEADERS, row });
}

export async function deleteCandidateFromSheets(id, url) {
  if (!url) return;
  await sheetsRequest(url, 'delete', 'Candidates', { id });
}

export async function deleteClientFromSheets(id, url) {
  if (!url) return;
  await sheetsRequest(url, 'delete', 'Clients', { id });
}
